import loadable from '@loadable/component';

export { default as translations } from './translations.json';
export { ProfileAddressesApi } from './ProfileAddressesApi';

export const ProfileAddressesPage = loadable(() =>
  import(/* webpackChunkName: "ProfileAddressesPage" */ './ProfileAddressesPage')
);
